import { useContext, useMemo, useState } from 'react'

import { HeaderContext } from '../..';
import { buildNavLink } from '@laramie/ui';
import { MunicipalityLogo } from '../../../../common'
import './index.scss'

const NavBarCompact = () => {
    const { isAuthenticated, publicRoutes, privateRoutes, handleClickHome, handleClickMenu, handleClickLogout, setModal } = useContext(HeaderContext)
    
    const [menuOpen, setMenuOpen] = useState(false)

    const onClickFinal = (index) => {
        setMenuOpen(false)
        handleClickMenu(index)
    }

    const topRoutes = useMemo(
        () => (isAuthenticated ? privateRoutes : publicRoutes).filter(route => route.nivelMenu === 1),
        [isAuthenticated, publicRoutes, privateRoutes]
    )

    return (
        <div className="navbar-compact">
            <div className="navbar-row">
                <div className='navlogo' onClick={handleClickHome}>
                    <MunicipalityLogo filename="LogoMunicipio.png" alt="logo" className="logo-img logo-default" />
                    <MunicipalityLogo filename="LogoMunicipioColor.png" alt="logo" className="logo-img logo-color" />
                </div>
        
                <div className="display-row" style={{ flex: 1 }}>
                    <a className="nav-link" href="#">
                        <div className="display-row" onClick={() => setMenuOpen(x => !x)}>
                            <span className="material-symbols-outlined">menu</span>
                            <div className="nav-item p-left-10">Menú</div>
                        </div>
                    </a>

                    {isAuthenticated && (
                        <a className="nav-link display-row" style={{ marginLeft: 'auto', }}>
                            <div className="nav-item nav-link-login">
                                <span className="material-symbols-outlined">account_circle</span></div>
                            <div onClick={ handleClickLogout } className="nav-item nav-link-login p-right-5">
                                <span className="power material-symbols-outlined">power_settings_new</span>
                            </div>
                        </a>
                    )}
                </div>
            </div>

            <div className={"navbar-compact-menu"} style={{ maxHeight: menuOpen ? topRoutes.length * 35 + 15 : 0 }}>
                {topRoutes.map((route, index) => (
                    (route.children.length === 0) ? (
                        <div className="" key={index} onClick={() => onClickFinal(null)}>
                            {buildNavLink(route, setModal)}
                        </div>
                    ) : (
                        <div className="dropdown" key={index}>
                            <a className="nav-link" href="#" onClick={() => handleClickMenu(route.index)}>
                                {route.title}
                            </a>
                            <ul className={(route.selected) ? "dropdown-menu show" : "dropdown-menu"} style={{ position: 'fixed' }}>
                                {privateRoutes.filter(subitem => route.children.includes(subitem.index) && subitem.nivelMenu === 2).map((subroute, subindex) =>
                                    <li key={subindex} onClick={() => onClickFinal(null)}>
                                        {buildNavLink(subroute, setModal)}
                                    </li>
                                )}
                            </ul>
                        </div>
                    )
                ))}
            </div>
        </div>
    )
}

export default NavBarCompact
